import { render, staticRenderFns } from "./view-common.vue?vue&type=template&id=4a52de69&scoped=true"
import script from "./view-common.vue?vue&type=script&lang=js"
export * from "./view-common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a52de69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a52de69')) {
      api.createRecord('4a52de69', component.options)
    } else {
      api.reload('4a52de69', component.options)
    }
    module.hot.accept("./view-common.vue?vue&type=template&id=4a52de69&scoped=true", function () {
      api.rerender('4a52de69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue-view/view-common.vue"
export default component.exports